export default [/\/mapsjs-core.js/, /\/clarity/];
